<template>
  <aw-dropdown placement="top-start" :offset="[0, -40]" class="relative z-5 DocumentHotActionDropdown">
    <template v-slot:btn="{ toggle, close }">
      <div @click="toggle">
        <!-- Simple hot action in element -->
        <div
          v-if="!canAddNewPage"
          class="DocumentHotAction relative h-0.25 bg-bc-blue"
        >
          <span>
            <aw-icon
              icon="plus"
              class="relative w-4 h-4 -mx-1  text-bc-blue"
            ></aw-icon>
          </span>
        </div>
        <!-- //Simple hot action in element -->

        <!-- advanced on the bottom page -->
        <!-- New look & behavior, wee see it immediately -->
        <div
          v-if="canAddNewPage && last"
          class="grid grid-cols-4 gap-4 py-4 [ sm:grid-cols-7 ]"
          v-aw-driver-element="'DocumentActions'"
        >
          <document-add-page
            v-if="canAddNewPage"
            :parent="bcDocumentStore.document"
            :page="page"
            :index="this.pageIndex"
            @onselect="close"
          />

          <document-add-header
            :parent="page"
            v-model:modelTakeChildren="parent"
            :page="page"
            :index="parent.type === 'header' ? parent.rank + 1 : index"
            :takeChildrenIndex="index"
            @onselect="close"
          />
          <document-add-text
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-color
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-table
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-embed
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-file
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
        </div>

        <div
          v-if="canAddNewPage && !last"
          class="Content__Document !p-0 !bg-transparent !shadow-none mx-auto"
        >
          <div
            class="Content__AddNewDocument cursor-pointer"
            :class="{
              'Content__AddNewDocument--ShowPermanently': visiblePermanently,
              'Content__AddNewDocument--LastElement': last
            }"
          >
            <div class="DocumentHotAction relative h-0.25 bg-bc-blue">
              <span class="gray">
                <span class="px-3 bg-bc-gray-bg text-bc-blue text-sm">
                  <aw-icon
                    icon="plus"
                    class="relative w-4 h-4 -mx-1 mr-1  text-bc-blue"
                  ></aw-icon>
                  <slot></slot>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- //advanced on the bottom page -->
      </div>
    </template>
    <template v-slot:dropdown="{ opened, dropdown, close }">
      <div
        v-show="opened"
        :ref="dropdown"
        class="Dropdown Dropdown--Full Dropdown--SuperShadow DropdownButtonPanel w-full absolute rounded bg-white max-w-xs text-sm top-full right-0 shadow z-10"
      >
        <div class="p-4 flex justify-between">
          <!-- New page -->
          <document-add-page
            v-if="canAddNewPage"
            :parent="bcDocumentStore.document"
            :page="page"
            :index="this.pageIndex"
            @onselect="close"
          />
          <!-- // New page -->

          <document-add-header
            :parent="page"
            v-model:modelTakeChildren="parent"
            :page="page"
            :index="parent.type === 'header' ? parent.rank + 1 : index"
            :takeChildrenIndex="index"
            @onselect="close"
          />
          <document-add-text
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-color
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-table
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-embed
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
          <document-add-file
            :parent="parent"
            :page="page"
            :index="index"
            @onselect="close"
          />
        </div>
      </div>
    </template>
  </aw-dropdown>
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'

export default {
  mixins: [BaseAddElement],
  props: ['pageIndex', 'visiblePermanently', 'last'],
  computed: {
    canAddNewPage() {
      return this.pageIndex !== undefined ? true : false
    },
    ...mapStores(useBcDocumentStore)
  }
}
</script>

<style lang="scss" scoped></style>
